<template>
  <div class="flex items-center flex-col py-6">
      <div class="flex flex-row justify-start pt-3 pb-2 mb-6 mt-2 border-b-2 flex-wrap w-11/12">
          <button 
            @click="$router.push({path: '/home'})"
            class="text-t14 flex justify-center items-center py-2 px-3 rounded-md bg-costeaBtn2 text-costeaPrimary mr-4 hover:bg-costeaHover hover:text-white">
              <i class="ri-arrow-left-line"></i>
          </button>
          <h1 class="font-costea text-h24 font-medium text-costeaBlack mb-4 md:mb-0">Reportes avanzados</h1>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>